export enum TranslationNamespace {
  common = 'common',
  page = 'page',
  classAssist = 'class-assist',
  gdpr = 'gdpr',
  errorPage = 'error-page',
  verificationResult = 'verification-result',
  team = 'team',
  problemSolutionCenter = 'problem-solution-center',
  officeAction = 'office-action',
}
